import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { ForgetPasswordApi } from "../../data/userData"; // Import your API call
import CircularProgress from "@mui/material/CircularProgress";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Swal from "sweetalert2";
import forgotpassword from "../../Assets/Images/forgotpassword.jpg";

const theme = createTheme();

export default function ForgotPasswordForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const email = formData.get("Email");

    setLoading(true);
    setErrorMessage(""); // Clear previous errors

    try {
      const response = await ForgetPasswordApi(email);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Password has been reset successfully. Please check your email.",
        });
        navigate("/signin");
      } else {
        throw new Error("Invalid Email");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Invalid Email or Error Occurred."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 2,
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${forgotpassword})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.8,
            zIndex: -1,
          }}
        ></div>

        <Paper
          component="form"
          noValidate
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
            borderRadius: "0.5rem",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(2px)",
            width: ["100%", "90%", "70%", "60%"],
            margin: "auto",
            [theme.breakpoints.up("sm")]: {
              width: "90%",
            },
            [theme.breakpoints.up("md")]: {
              width: "60%",
            },
            [theme.breakpoints.up("lg")]: {
              width: "30%",
            },
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <TextField
            margin="normal"
            required
            fullWidth
            id="Email"
            label="Email"
            name="Email"
            type="email"
            autoComplete="off"
            error={!!errorMessage}
            helperText={errorMessage} // Show error message
            disabled={loading} // Disable input while loading
            sx={{ marginBottom: 2 }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading} // Disable button while loading
            startIcon={
              loading && <CircularProgress size={20} color="inherit" />
            } // Spinner during loading
          >
            {loading ? "Processing..." : "Reset Password"}
          </Button>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
